import { UTILSURL } from "helpers/constant";
import { callApi } from "Apis";

export async function updateStatusApi(data) {
  try {
    const response = await callApi({ url: UTILSURL.UPDATE_STATUS, body: data, method: "post" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function getJsonData() {
  try {
    const response = await callApi({ url: UTILSURL.GET_JSON, method: "post" });
    return response;
  } catch (err) {
    throw err;
  }
}
